import { Config } from 'effect'

import { PublicEnvironmentConfig as PublicEnvironmentConfigEnvironment } from './environment/public.environment.ts'

export const PublicEnvironmentConfig = Config.all({
  appEnvironment: PublicEnvironmentConfigEnvironment.PUBLIC_APP_ENV,
})

export const PublicApiConfig = Config.all({
  apiEndpoint: PublicEnvironmentConfigEnvironment.PUBLIC_API_ENDPOINT,
})

export const PublicOtelConfig = Config.all({
  serviceName: PublicEnvironmentConfigEnvironment.PUBLIC_OTEL_SERVICE_NAME,
})

export * from './shared.ts'
